import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Grid2 } from "@mui/material";
import axios from "axios";
import { XMLParser } from "fast-xml-parser";
import IndependentDataCheck from "../adTesting/independentDataCheck";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

let regions = ["ne", "phx"];
let series = [];
let envs = ["Live", "Staging"];

function PHXVastCampaigns(mode) {
	// const [focusRegion, setFocusRegion] = React.useState();
	// const [focusSeries, setFocusSeries] = React.useState();
	// const [focusEnv, setFocusEnv] = React.useState();
	// const [seriesAPI, setSeriesAPI] = React.useState([]);

	console.log(mode);
	React.useEffect(() => {
		// loadSeriesAPI();
		// //get qs vars and poulate the focusRegion and focusSeries
		// const queryString = window.location.search;
		// const urlParams = new URLSearchParams(queryString);
		// setFocusSeries(urlParams.get("series"));
		// setFocusRegion(urlParams.get("region"));
		// setFocusEnv(urlParams.get("env"));
		// if (focusSeries && focusRegion && focusEnv) {
		// createVastAd(focusSeries, focusRegion, focusEnv);
		createVastAd();
		// }
	}, []);
	// React.useEffect(() => {
	// 	console.log("regionJSON updated");
	// 	console.log(regionJSON);
	// 	if (focusSeries) {
	// 		console.log("running offer data");
	// 		getOfferData();
	// 	}
	// }, [regionJSON]);

	// React.useEffect(() => {
	// 	console.log("----- ", focusRegion, focusSeries);
	// 	if ((focusRegion, focusSeries)) {
	// 		createVastAd(focusSeries, focusRegion);

	// 		if (focusSeries && focusRegion && focusEnv) {
	// 			const queryString = `?series=${focusSeries}&region=${focusRegion}&env=${focusEnv}&mode=phxvastcampaigns`;
	// 			window.history.pushState({}, "", queryString);
	// 		}
	// 	}
	// }, [focusRegion, focusSeries, focusEnv]);

	// async function loadSeriesAPI() {
	// 	const response = await fetch(
	// 		"https://cdn.flashtalking.com/feeds/tcaa/ad_services/helpers/seriesapi/seriesapi.json"
	// 	);
	// 	const data = await response.json();
	// 	//add the No Series
	// 	data.push({
	// 		seriesname: "No Series",
	// 		seriescode: "noseries",
	// 		toyotaAPIName: "noseries"
	// 	});
	// 	//alphabetize the series
	// 	data.sort((a, b) => (a.seriesname > b.seriesname ? 1 : -1));
	// 	setSeriesAPI(data);
	// 	console.log(series);
	// }
	// async function createVastAd(focusSeries, focusRegion) {
	async function createVastAd() {
		console.log("createVastAd");
		let phxJSONObjs = [
			{
				pli: "8557771",
				name: "PHX-DAT-VAST-PREROLL-15 - 1920x1080",
				div: "one"
			},
			{
				pli: "8557776",
				name: "PHX-DAT-VAST-CTV-30 - 1920x1080",
				div: "two"
			},
			{
				pli: "8565492",
				name: "PHX-DAT-VAST-PREROLL-30 - 1920x1080",
				div: "three"
			},
			{
				pli: "9114227",
				name: "PHX-DAT-VAST-CTV-15 - 1920x1080",
				div: "four"
			}
		];
		for (let i = 0; i < phxJSONObjs.length; i++) {
			var xml = "";
			// const vastTagUrl = `https://servedby.flashtalking.com/imp/8/259500;8999368;208;xml;test;STAGINGTESTVAST/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&pbMethods=[PLAYBACKMETHODS]|[CONTINUOUSPLAY]|[TIMESINCEINTERACTION]&cachebuster=${Math.floor(

			// this needs to be updated once we get a new phx tag
			let vastTagUrl =
				"https://servedby.flashtalking.com/imp/8/245866;" +
				phxJSONObjs[i].pli +
				";208;xml;Nexxen;PHXDATVASTPREROLL15/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&ft_c1=medium_value&ft_c2=custom_value&ft_keyword=keyword_macro&ft_section=keyword_macro&pbMethods=[PLAYBACKMETHODS]|[CONTINUOUSPLAY]|[TIMESINCEINTERACTION]&cachebuster=" +
				Math.floor(Math.random() * 1000000);
			// "https://servedby.flashtalking.com/imp/8/245866;8557771;208;xml;test;PHXVAST15TEST/?gdpr=%24%7BGDPR%7D&ft_keyword=" +
			// focusSeries +
			// "&gdpr_consent=%24%7BGDPR_CONSENT_78%7D&us_privacy=%24%7BUS_PRIVACY%7D&pbMethods=%5BPLAYBACKMETHODS%5D%7C%5BCONTINUOUSPLAY%5D%7C%5BTIMESINCEINTERACTION%5D&cachebuster=" +
			// Math.floor(Math.random() * 1000000);

			console.log(vastTagUrl);
			const response = await axios.get(vastTagUrl);
			xml = response.data;

			const parser = new XMLParser();
			const json = parser.parse(xml);
			console.log(json);

			// Assuming you want to render the video using the VAST tag
			const videoElement = document.createElement("video");
			videoElement.setAttribute("controls", "controls");
			videoElement.addEventListener("click", () => {
				window.open(
					json.VAST.Ad.InLine.Creatives.Creative[0].Linear.VideoClicks
						.ClickThrough,
					"_blank"
				);
			});

			const sourceElement = document.createElement("source");
			console.log(
				json.VAST.Ad.InLine.Creatives.Creative[0].Linear.MediaFiles.MediaFile[2]
			);
			sourceElement.setAttribute(
				"src",
				json.VAST.Ad.InLine.Creatives.Creative[0].Linear.MediaFiles.MediaFile[2]
			);
			sourceElement.setAttribute("type", "video/mp4");

			videoElement.appendChild(sourceElement);
			const adsContainer = document.getElementById("ads" + phxJSONObjs[i].div);
			adsContainer.innerHTML = ""; // Clear the ads tag
			adsContainer.appendChild(videoElement);
			// await getLiveXML(focusRegion);

			//mute the video player
			videoElement.muted = true;
			//add the title
			document.getElementById(
				"meta" + phxJSONObjs[i].div
			).innerHTML = `${phxJSONObjs[i].name}`;
		}
	}

	// async function getLiveXML(region) {
	// 	console.log("getLiveXML");

	// 	//fetch xml files at https://xmlconverter.datcdn.com/phx_facebook_nf_2.xml
	// 	// axios
	// 	// 	.get(
	// 	// 		`https://dat-vps.com//tcaautilities/toyotascreenscrape/fb_marketing_feed_${region}.xml`
	// 	// 	)
	// 	// 	.then((response) => {
	// 	// 		console.log(response.data);
	// 	// 		const parser = new XMLParser();
	// 	// 		const json = parser.parse(response.data);
	// 	// 		setRegionJSON(json);
	// 	// 		console.log(json);
	// 	// 		getOfferData(json);
	// 	// 	})
	// 	// 	.catch((error) => {
	// 	// 		console.error("There was an error!", error);
	// 	// 	});
	// }

	return (
		<div id="htmlPage" style={{ display: "flex", flexDirection: "column" }}>
			<h1>PHX Vast Campaigns Test Page</h1>
			<Grid2 container spacing={5}>
				{/* <Grid2 container spacing={2} direction="column">
                    <FormControl sx={{ m: 1, width: 300 }}>
                        <InputLabel id="region-select-label">Region</InputLabel>
                        <Select
                            labelId="region-select-label"
                            id="region-select"
                            value={focusRegion ? focusRegion : ""}
                            onChange={(e) => setFocusRegion(e.target.value)}
                            input={<OutlinedInput label="Region" />}
                            MenuProps={MenuProps}
                        >
                            {regions.map((region) => (
                                <MenuItem key={region} value={region}>
                                    <ListItemText primary={region} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl sx={{ m: 1, width: 300 }}>
                        <InputLabel id="env-select-label">Environment</InputLabel>
                        <Select
                            labelId="env-select-label"
                            id="env-select"
                            input={<OutlinedInput label="Environment" />}
                            MenuProps={MenuProps}
                            value={focusEnv ? focusEnv : ""}
                            onChange={(e) => setFocusEnv(e.target.value)}
                        >
                            {envs.map((env) => (
                                <MenuItem key={env} value={env}>
                                    <ListItemText primary={env} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl sx={{ m: 1, width: 300 }}>
                        <InputLabel id="series-select-label">Series</InputLabel>
                        <Select
                            labelId="series-select-label"
                            id="series-select"
                            value={focusSeries ? focusSeries : ""}
                            onChange={(e) => setFocusSeries(e.target.value)}
                            input={<OutlinedInput label="Series" />}
                            MenuProps={MenuProps}
                        >
                            {seriesAPI.map((series) => (
                                <MenuItem key={series.seriesname} value={series.seriesname}>
                                    <ListItemText primary={series.seriesname} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid2> */}
				<Grid2 container xs={12} class="phxvastholder">
					<Grid2 container xs={12}>
						<h2 id="metaone"></h2>
					</Grid2>

					<Grid2 container xs={12} id="adsone"></Grid2>
				</Grid2>
				<Grid2 container xs={12} class="phxvastholder">
					<Grid2 container xs={12}>
						<h2 id="metatwo"></h2>
					</Grid2>
					<Grid2 container xs={12} id="adstwo"></Grid2>
				</Grid2>
				<Grid2 container xs={12} class="phxvastholder">
					<Grid2 container xs={12}>
						<h2 id="metathree"></h2>
					</Grid2>
					<Grid2 container xs={12} id="adsthree"></Grid2>
				</Grid2>
				<Grid2 container xs={12} class="phxvastholder">
					<Grid2 container xs={12}>
						<h2 id="metafour"></h2>
					</Grid2>
					<Grid2 container xs={12} id="adsfour"></Grid2>
				</Grid2>
			</Grid2>
			{/* {seriesAPI.length && focusSeries && focusRegion && (
                <IndependentDataCheck
                    seriesAPIData={seriesAPI}
                    theFocusSeries={focusSeries}
                    theFocusRegion={focusRegion}
                />
            )} */}
		</div>
	);
}

export default PHXVastCampaigns;
